// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-itinerary-modal-wrapper .heading-text {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.03em;
}
.preview-itinerary-modal-wrapper .guest-details-wrapper {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 20px;
}
.preview-itinerary-modal-wrapper .guest-details-wrapper span {
  color: #3a3a3a;
}
.preview-itinerary-modal-wrapper .guest-details-wrapper .detail-name {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.03em;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper {
  max-height: 50vh;
  max-width: 80vw;
  overflow: auto;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper input {
  display: none;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper label {
  position: relative;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.03em;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper label:before {
  content: "";
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  border: 1px solid #c2c2c2;
  border-radius: 2px;
  padding: 8px;
  margin-right: 10px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper input:checked + label:before {
  border: 1px solid #92278f;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper input:checked + label:after {
  content: "";
  display: block;
  position: absolute;
  top: 6px;
  left: 7px;
  width: 5px;
  height: 10px;
  border: solid #92278f;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper {
  border: 1px solid #ddd;
  border-radius: 6px;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper span {
  color: #3a3a3a;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-name {
  border-bottom: 1px solid #ddd;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-duration {
  border-bottom: 1px solid #ddd;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-duration span {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.03em;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-duration .trip-type {
  color: #c35379;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-transit {
  border-bottom: 1px solid #ddd;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-transit .blue,
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-transit .purple {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.03em;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-transit .blue {
  color: #1E8EDF;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-transit .purple {
  color: #92278F;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-transit .transit-date, .preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-transit .transit-time {
  font-size: 14px;
  font-weight: 400;
  color: #7a7a7a;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-cabins .cabins-heading,
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-cabins .no-cabins {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.03em;
  color: #3a3a3a;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-cabins .no-cabins {
  color: #D40D0D;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-cabins .cabin-name {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.03em;
  color: #e06d6c;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-cabins .red,
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-cabins .green {
  font-size: 14px;
  font-weight: 400;
  line-height: 18.23px;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-cabins .red {
  color: #D40D0D;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper .itinerary-cabins .green {
  color: #17A300;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .itinerary-details-card-wrapper:has(input:checked) {
  background-color: #f8f7f7;
  border: 1px solid #92278f;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .details-checkbox input:checked + label:before {
  border: 1px solid #e06d6c;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .details-checkbox input:checked + label:after {
  top: 4px;
  left: 6.5px;
  border: solid #e06d6c;
  border-width: 0 2px 2px 0;
}
.preview-itinerary-modal-wrapper .itinerary-details-cards-wrapper .details-checkbox label {
  font-size: 14px;
  font-weight: 400;
  color: #AAAAAA;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/PreviewItineraryModal/style.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;AAAR;AAGI;EACI,sBAAA;EACA,kBAAA;EACA,aAAA;AADR;AAGQ;EACI,cAAA;AADZ;AAIQ;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;AAFZ;AAMI;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAJR;AAMQ;EACI,aAAA;AAJZ;AAOQ;EACI,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AALZ;AAQQ;EACI,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AANZ;AASQ;EACI,yBAAA;AAPZ;AAUQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;AARZ;AAWQ;EACI,sBAAA;EACA,kBAAA;AATZ;AAWY;EACI,cAAA;AAThB;AAYY;EACI,6BAAA;AAVhB;AAaY;EACI,6BAAA;AAXhB;AAagB;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;AAXpB;AAcgB;EACI,cAAA;AAZpB;AAgBY;EACI,6BAAA;AAdhB;AAgBgB;;EAEI,eAAA;EACA,gBAAA;EACA,sBAAA;AAdpB;AAiBgB;EACI,cAAA;AAfpB;AAkBgB;EACI,cAAA;AAhBpB;AAmBgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAjBpB;AAuBgB;;EAEI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AArBpB;AAwBgB;EACI,cAAA;AAtBpB;AAyBgB;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AAvBpB;AA0BgB;;EAEI,eAAA;EACA,gBAAA;EACA,oBAAA;AAxBpB;AA2BgB;EACI,cAAA;AAzBpB;AA4BgB;EACI,cAAA;AA1BpB;AA+BQ;EACI,yBAAA;EACA,yBAAA;AA7BZ;AAiCY;EACI,yBAAA;AA/BhB;AAkCY;EACI,QAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;AAhChB;AAmCY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAjChB","sourcesContent":[".preview-itinerary-modal-wrapper {\n    .heading-text {\n        font-size: 22px;\n        font-weight: 700;\n        letter-spacing: 0.03em;\n    }\n\n    .guest-details-wrapper {\n        border: 1px solid #ddd;\n        border-radius: 6px;\n        padding: 20px;\n\n        span {\n            color: #3a3a3a;\n        }\n\n        .detail-name {\n            font-size: 18px;\n            font-weight: 500;\n            letter-spacing: 0.03em;\n        }\n    }\n\n    .itinerary-details-cards-wrapper {\n        max-height: 50vh;\n        max-width: 80vw;\n        overflow: auto;\n\n        input {\n            display: none;\n        }\n\n        label {\n            position: relative;\n            cursor: pointer;\n            font-size: 16px;\n            font-weight: 700;\n            letter-spacing: 0.03em;\n        }\n\n        label:before {\n            content: '';\n            appearance: none;\n            -webkit-appearance: none;\n            background-color: transparent;\n            border: 1px solid #c2c2c2;\n            border-radius: 2px;\n            padding: 8px;\n            margin-right: 10px;\n            display: inline-block;\n            position: relative;\n            vertical-align: middle;\n            cursor: pointer;\n        }\n\n        input:checked+label:before {\n            border: 1px solid #92278f;\n        }\n\n        input:checked+label:after {\n            content: '';\n            display: block;\n            position: absolute;\n            top: 6px;\n            left: 7px;\n            width: 5px;\n            height: 10px;\n            border: solid #92278f;\n            border-width: 0 2px 2px 0;\n            transform: rotate(45deg);\n        }\n\n        .itinerary-details-card-wrapper {\n            border: 1px solid #ddd;\n            border-radius: 6px;\n\n            span {\n                color: #3a3a3a;\n            }\n\n            .itinerary-name {\n                border-bottom: 1px solid #ddd;\n            }\n\n            .itinerary-duration {\n                border-bottom: 1px solid #ddd;\n\n                span {\n                    font-size: 14px;\n                    font-weight: 400;\n                    letter-spacing: 0.03em;\n                }\n\n                .trip-type {\n                    color: #c35379;\n                }\n            }\n\n            .itinerary-transit {\n                border-bottom: 1px solid #ddd;\n\n                .blue,\n                .purple {\n                    font-size: 16px;\n                    font-weight: 500;\n                    letter-spacing: 0.03em;\n                }\n\n                .blue {\n                    color: #1E8EDF;\n                }\n\n                .purple {\n                    color: #92278F;\n                }\n\n                .transit-date, .transit-time {\n                    font-size: 14px;\n                    font-weight: 400;\n                    color: #7a7a7a;\n                }\n            }\n\n            .itinerary-cabins {\n\n                .cabins-heading,\n                .no-cabins {\n                    font-size: 16px;\n                    font-weight: 500;\n                    letter-spacing: 0.03em;\n                    color: #3a3a3a;\n                }\n\n                .no-cabins {\n                    color: #D40D0D;\n                }\n\n                .cabin-name {\n                    font-size: 18px;\n                    font-weight: 500;\n                    letter-spacing: 0.03em;\n                    color: #e06d6c;\n                }\n\n                .red,\n                .green {\n                    font-size: 14px;\n                    font-weight: 400;\n                    line-height: 18.23px;\n                }\n\n                .red {\n                    color: #D40D0D;\n                }\n\n                .green {\n                    color: #17A300;\n                }\n            }\n        }\n\n        .itinerary-details-card-wrapper:has(input:checked) {\n            background-color: #f8f7f7;\n            border: 1px solid #92278f;\n        }\n\n        .details-checkbox {\n            input:checked+label:before {\n                border: 1px solid #e06d6c;\n            }\n\n            input:checked+label:after {\n                top: 4px;\n                left: 6.5px;\n                border: solid #e06d6c;\n                border-width: 0 2px 2px 0;\n            }\n\n            label {\n                font-size: 14px;\n                font-weight: 400;\n                color: #AAAAAA;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
